export const MODEL_ROUTE = '/drugs';
